import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const UpcomingNavItem = ({ count }) => (
  <li>
    <Link to="/profile/upcoming">
      <FormattedMessage id="header.link.upcoming" defaultMessage="Upcoming" />
      {count > 0 && <span className="header__badge">{count}</span>}
    </Link>
  </li>
);

UpcomingNavItem.propTypes = {
  count: PropTypes.number,
};
